import { defineRecipe } from '@chakra-ui/react';
export const inputRecipe = defineRecipe({
    base: {
        rounded: 'md',
        width: '100%',
        minWidth: 0,
        outline: 'transparent solid 2px',
        outlineOffset: '0.5px',
        position: 'relative',
        appearance: 'none',
        transitionProperty: 'common',
        transitionDuration: 'normal',
        // Charcoal focus ring (interactive = charcoal in the rebrand role system).
        colorPalette: 'primary',
        _disabled: {
            opacity: 0.4,
            cursor: 'not-allowed',
        },
    },
    variants: {
        variant: {
            outline: {
                borderWidth: '1px',
                borderColor: 'border',
                bg: 'bg',
                _hover: {
                    borderColor: 'border.emphasized',
                },
                _focus: {
                    outline: '2px solid',
                    outlineOffset: '0.5px',
                    outlineColor: 'colorPalette.focusRing/15',
                    zIndex: 1,
                    borderColor: 'colorPalette.focusRing',
                    boxShadow: '0 0 0 1px var(--chakra-colors-colorPalette-focusRing)',
                },
                _invalid: {
                    borderColor: 'border.error',
                    _focus: {
                        borderColor: 'border.error',
                        boxShadow: '0 0 0 1px var(--chakra-colors-border-error)',
                    },
                },
            },
        },
        // Creator space fields: 48px and the 14px radius on a phone, 44px and
        // 12px on a computer.
        size: {
            creator: {
                h: { base: '48px', md: '44px' },
                px: '14px',
                rounded: { base: 'control', md: 'lg' },
                fontSize: { base: '15px', md: '14.5px' },
            },
        },
    },
    defaultVariants: {
        variant: 'outline',
    },
});
